module.exports = __webpack_public_path__ + "img/external-tab.34c2c146.svg";